import { createContext, useContext } from 'react';

/**
 * What a row inside the desktop rail can ask of it: show my label in a bubble
 * while I have keyboard focus, and take it away when I lose it. The rail
 * (`sidebar.tsx`) decides whether a bubble is warranted — closed, and the
 * focus came from a keyboard — the row only reports. Its own file so the user
 * card can ask without importing the rail that mounts it.
 */
export interface RailTip {
  onFocus: (label: string, anchor: HTMLElement) => void;
  onBlur: () => void;
}

export const RailTipContext = createContext<RailTip | null>(null);

/** Null outside the rail — the slide-over panel shows every label and needs no bubble. */
export function useRailTip(): RailTip | null {
  return useContext(RailTipContext);
}
